var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.8132 6.49287C3.6222 6.49287 3.4292 6.42291 3.2832 6.28203L0.909203 4.00791C0.616203 3.72712 0.616203 3.27287 0.909203 2.99207C1.2022 2.71128 1.6762 2.71128 1.9692 2.99207L3.8132 4.75732L8.0292 0.717949C8.3222 0.437157 8.7962 0.437157 9.0892 0.717949C9.3822 0.99874 9.3822 1.45299 9.0892 1.73378L4.3432 6.28203C4.1972 6.42291 4.0052 6.49287 3.8132 6.49287Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.728894c6be0954ad301c7fb1a9d19f9a.svg";
export { ForwardRef as ReactComponent };